<template>
  <v-container elevation-5 mt-3 px-4>
    <v-form ref="form">
      <v-layout>
        <v-flex text-xs-center my-3>
          <div class="display-2 mb-1">{{ routeInfo }}</div>
          <div class="display-1">Contact Form</div>
        </v-flex>
      </v-layout>
      <div class="title">Name</div>
      <v-layout wrap>
        <v-flex :class="breakpointMargin">
          <v-text-field
            v-model="name.first"
            :rules="[required]"
            label="First Name"
            autocomplete="given-name"
          />
        </v-flex>
        <v-flex :class="breakpointMargin">
          <v-text-field
            v-model="name.last"
            :rules="[required]"
            label="Last Name"
            autocomplete="family-name"
          />
        </v-flex>
      </v-layout>
      <div class="title mt-3">Email</div>
      <v-text-field
        v-model="email"
        :rules="[required, emailTest]"
        type="email"
        label="Email Address"
        autocomplete="email"
      />
      <div class="title mt-3">Address</div>
      <v-text-field
        v-model="street.first"
        :rules="[required]"
        label="Street Address"
        autocomplete="street-address address-line1"
      />
      <v-text-field
        v-model="street.second"
        label="Street Address Line 2"
        autocomplete="street-address address-line2"
      />
      <v-layout wrap>
        <v-flex :class="breakpointMargin">
          <v-text-field
            v-model="city"
            :rules="[required]"
            label="City"
            autocomplete="address-level2"
          />
        </v-flex>
        <v-flex :class="breakpointMargin">
          <v-select
            v-model="state"
            :items="states"
            :rules="[required]"
            label="State"
            browser-autocomplete="address-level1"
            autocomplete
          />
        </v-flex>
        <v-flex :class="breakpointMargin">
          <v-text-field v-model="zip" :rules="[required]" label="Zip Code" />
        </v-flex>
      </v-layout>
      <div class="title mt-3">Phone</div>
      <v-text-field
        v-model.number="phone"
        :rules="[required, phoneTest]"
        name="phone"
        label="Phone Number"
        autocomplete="tel-national"
        type="tel"
        mask="phone"
      />
      <v-layout justify-center fill-height> <v-btn @click="submit">Submit</v-btn> </v-layout>
    </v-form>
    <v-alert :value="alert.show" :type="alert.type" transition="slide-y-transition" dismissable>
      {{ alert.content }}
    </v-alert>
  </v-container>
</template>

<script>
import { database as db } from 'firebase/app';
import 'firebase/database';
import { mapState } from 'vuex';
import { omit } from 'lodash-es';
import { states, emailRegex } from './util';

const routeMap = {
  amend: 'Coporate Amendments',
  'attorney-health': 'Health Care Power of Attorney',
  attorney: 'Power of Attorney',
  conversion: 'Conversion',
  dba: 'DBA / Ficticious Business Name',
  deed: 'Property Deed',
  dissolution: 'Dissolution',
  ein: 'Federal Tax ID (EIN)',
  foreign: 'Foreign Qualification',
  international: 'International Trademark Filing',
  'last-will': 'Last Will and Testament',
  legal: 'Legal Help',
  license: 'Business Licenses',
  'living-trust': 'Living Trust',
  'living-will': 'Living Will',
  monitor: 'Trademark Monitoring',
  'name-change': 'Coporate Name Change',
  'other-trademark': 'Other Trademark Filings',
  personal: 'Personal Legal Plan',
  pet: 'Pet Protection Agreement',
  search: 'Trademark Search',
  sou: 'Trademark Statement of Use',
  trademark: 'Trademark Business',
};

export default {
  data: () => ({
    alert: { show: false, type: 'success', content: null },
    city: null,
    email: null,
    name: { first: null, last: null },
    phone: null,
    state: null,
    states,
    street: { first: null, second: null },
    zip: null,
  }),
  computed: {
    ...mapState(['token']),
    breakpointMargin() {
      return {
        'mx-2': this.$vuetify.breakpoint.smAndUp,
      };
    },
    routeInfo() {
      return routeMap[this.$route.params.route];
    },
  },
  mounted() {
    return this.$store.dispatch('setToken');
  },
  methods: {
    required: field => !!field || 'This field is required',
    emailTest: field => emailRegex.test(field) || 'Please enter a valid email',
    phoneTest: field => /^\d{10}$/.test(field) || 'Please enter a valid phone number',
    async submit() {
      if (!this.$refs.form.validate()) return;
      try {
        await db()
          .ref(`info/${this.token}/`)
          .set({
            contact: omit(this.$data, ['states', 'alert']),
            route: this.$route.params.route,
          });
        this.alert.type = 'success';
        this.alert.content = "Thanks! We'll get in contact with you real soon";
        this.alert.show = true;
      } catch (e) {
        this.alert.type = 'error';
        this.alert.content = 'Something went wrong.';
        this.alert.show = true;
        console.error(e); // eslint-disable-line no-console
      }
    },
  },
};
</script>
